import { StorageHelper } from '@smg-real-estate/hg-search-libs';

import { HgLocalStorageKey } from '@/models/HgLocalStorageKey';
import { StorageNamespace } from '../storage-namespaces';

let searchResultStorage: StorageHelper | null = null;

function getSearchResultStorage(): StorageHelper {
  if (!searchResultStorage) {
    searchResultStorage = new StorageHelper(StorageNamespace.searchResults);
  }

  return searchResultStorage;
}

export function getHiddenListings(): string[] {
  return getSearchResultStorage().getLocalStorageItem(HgLocalStorageKey.HIDDEN_LISTING_IDS) || [];
}

function setHiddenListings(listingIds: string[]): void {
  getSearchResultStorage().setLocalStorageItem(HgLocalStorageKey.HIDDEN_LISTING_IDS, listingIds);
}

export function addHiddenListing(listingId: string): void {
  const hiddenListings = getHiddenListings();

  if (!hiddenListings.includes(listingId)) {
    hiddenListings.push(listingId);
    setHiddenListings(hiddenListings);
  }
}

export function removeHiddenListing(listingId: string): void {
  const hiddenListings = getHiddenListings();
  const filteredListings = hiddenListings.filter((id) => id !== listingId);

  setHiddenListings(filteredListings);
}

export function isListingHidden(listingId: string): boolean {
  const hiddenListings = getHiddenListings();

  return hiddenListings.includes(listingId);
}
